import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  HazardTable,
} from './DocumentPage';

const WorkplaceTransportDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Workplace Transport – Risk Assessment"
    documentHeading="Risk Assessment 09: Workplace Transport"
    meta={[
      ['Document Reference', 'PVS-RA-09'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Area / Location', 'Yard Area'],
      ['Activity', 'Movement of forklift trucks, wagons and other vehicles around the external yard areas'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Workplace Transport – Risk Assessment',
      documentReference: 'PVS-RA-09',
      processActivity: 'Workplace Transport',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Scope">
      <Paragraph>
        This assessment covers the movement of forklift trucks, wagons and other vehicles around the
        external yard areas of Pressure Vessel Services Limited and applies to employees,
        contractors, visitors and members of the public entering site.
      </Paragraph>
    </Section>

    <Section number="2" title="Hazard Identification and Risk Assessment">
      <HazardTable
        columns={['Hazard Category', 'Hazards', 'Control Measures Already in Place', 'Additional Control Measures Required']}
        rows={[
          [
            'Workplace Transport / Driving On Site',
            [
              'Vehicle / pedestrian movements (including reversing) throughout the site resulting in collision with pedestrians, buildings / property or other vehicles.',
              'Customers / employees / third parties slipping / tripping e.g. ice in winter months etc.',
            ],
            [
              'Management / Supervision of site activities and driver competence: Driving licenses are checked when all new staff start; company vehicles are serviced/maintained on a regular basis; the site is a mandatory Hi-Viz wear site.',
              "Site layout / internal traffic routes: Pedestrian routes and traffic routes are in a reasonable state of repair; sufficient space to allow pedestrians and other road users to safely pass one another; loading/unloading of vehicles is undertaken on the road outside and/or in a designated area on site; unauthorised persons are kept out of this area; external and internal lighting is appropriate; rock salt is available on site in the winter months.",
              'Commercial Vehicles (HGV): Reversing movements are properly supervised; where fitted, reversing alarms, cameras etc are kept in working order.',
            ],
            "Display a 10 mph speed limit sign along with a 'forklift truck in use' and 'Hi-viz must be worn' sign at the entrance gate into the site.",
          ],
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        You have a duty not only to protect your own health and safety but also to ensure that your
        actions do not put others around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default WorkplaceTransportDoc;
